module.exports = __webpack_public_path__ + "static/media/taylor-momsen.f327fe91.jpg";